var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m24.577 11.382-1.333-.818c-1.337-.82-2.005-1.23-2.744-1.23-.739 0-1.407.41-2.744 1.23l-1.333.818c-1.265.776-1.897 1.164-2.243 1.79-.347.624-.347 1.378-.347 2.887v7.82c0 2.571 0 3.857.781 4.655.781.8 2.039.8 4.553.8h2.666c2.515 0 3.772 0 4.553-.8.78-.798.78-2.084.78-4.655v-7.82c0-1.509 0-2.263-.345-2.888-.347-.625-.979-1.013-2.244-1.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.167 9.477c-.852-.817-1.362-1.247-2.004-1.408-.746-.188-1.53.023-3.1.444l-1.564.42c-1.484.398-2.226.597-2.742 1.089-.515.492-.715 1.19-1.115 2.59l-2.07 7.25c-.682 2.385-1.022 3.577-.444 4.516.497.808 2.483 1.8 4.372 2.289"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M19.826 13.333c1.122-.746 2.118-1.943 2.736-3.431 1.278-3.073.464-6.226-1.817-7.041-2.281-.816-5.166 1.014-6.443 4.087a8.053 8.053 0 0 0-.469 1.537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.db4703b1292ba927d593f748cdb501c7.svg";
export { ForwardRef as ReactComponent };